import { useState } from "react";
import NavBar from "@/components/site/NavBar";
import Hero from "@/components/site/Hero";
import OfferStrip from "@/components/site/OfferStrip";
import Philosophy from "@/components/site/Philosophy";
import MenuPreview from "@/components/site/MenuPreview";
import MatchaPass from "@/components/site/MatchaPass";
import Faq from "@/components/site/Faq";
import Footer from "@/components/site/Footer";
import FoundingMemberModal from "@/components/founding/FoundingMemberModal";
import MatchaPassPurchaseModal from "@/components/founding/MatchaPassPurchaseModal";
import { useFoundingStats } from "@/lib/useFoundingStats";
import { trackEvent } from "@/lib/analytics";
import { toast } from "sonner";

export default function HomePage() {
  const [foundingOpen, setFoundingOpen] = useState(false);
  const [passOpen, setPassOpen] = useState(false);
  const [passTier, setPassTier] = useState("five");
  const { stats, refresh } = useFoundingStats();

  const openFounding = () => {
    trackEvent("free_matcha_click", { cta: "become_founding_member" });
    if (stats.founders_closed) {
      toast(
        stats.passes_closed
          ? `All ${stats.total_cap ?? 100} founding spots are claimed. Thank you.`
          : `All ${stats.founders_total ?? 45} free founding spots are gone — grab a Matcha Pass instead.`,
      );
      if (!stats.passes_closed) {
        setPassTier("five");
        setPassOpen(true);
      }
      return;
    }
    setFoundingOpen(true);
  };

  const openBuyPass = (tier) => {
    trackEvent(tier === "ten" ? "matcha_pass_10_click" : "matcha_pass_5_click", { tier });
    if (stats.passes_closed) {
      toast("All Matcha Pass spots are claimed. Thank you.");
      return;
    }
    setPassTier(tier);
    setPassOpen(true);
  };

  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="home-page">
      <NavBar onJoin={openFounding} stats={stats} />
      <Hero onJoin={openFounding} stats={stats} />
      <OfferStrip stats={stats} />
      <Philosophy />
      <MenuPreview />
      <MatchaPass onJoin={openFounding} onBuyPass={openBuyPass} stats={stats} />
      <Faq />
      <Footer onJoin={openFounding} stats={stats} />
      <FoundingMemberModal
        open={foundingOpen}
        onOpenChange={(o) => { setFoundingOpen(o); if (!o) refresh(); }}
      />
      <MatchaPassPurchaseModal
        open={passOpen}
        onOpenChange={(o) => { setPassOpen(o); if (!o) refresh(); }}
        tier={passTier}
      />
    </div>
  );
}
